import { createRouter, createWebHistory } from "vue-router";
import _ from "lodash";
import Common from "@/util/common.js";
import { KINYU_CODE_LIST } from "@/util/data.js";
const routes = [
  {
    path: '/',
    redirect: '/cl/login'
  },
  {
    path: "/fm/login",
    name: "STDSCM01C01",
    component: () =>
      import(
        /* webpackChunkName: "STDSCM01C01" */ "@/views/CM01/STDSCM01C01Login.vue"
      ),
    meta: {
      title: "ログイン | TATSUZIN",
      icon: "favicon.ico",
    },
  },
  {
    path: "/fm/datacollectionmain",
    name: "STDSDC01C01",
    component: () =>
      import(
        /* webpackChunkName: "STDSDC01C01" */ "@/views/DC01/STDSDC01C01DataCollectionMain.vue"
      ),
    meta: {
      title: "データ収集・配信サービスへようこそ | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  },
  {
    path: "/cl/login",
    name: "STDSCM01C02",
    component: () =>
      import(
        /* webpackChunkName: "STDSCM01C02" */ "@/views/CM01/STDSCM01C02Login.vue"
      ),
    meta: {
      title: "ログイン | TATSUZIN",
      icon: "favicon.ico",
    },
  },
  {
    path: "/oidc/login",
    name: "STDSCM01C05",
    component: () =>
      import(
        /* webpackChunkName: "STDSCM01C02" */ "@/views/CM01/STDSCM01C05Login.vue"
      ),
    meta: {
      title: "電帳法オプションへようこそ| TATSUZIN",
      icon: "favicon.ico",
    },
  },
  {
    path: "/cm/variouserrors",
    name: "STDSCM04C06",
    component: () =>
      import(
        /* webpackChunkName: "STDSCM04C06" */ "@/views/CM04/STDSCM04C06VariousErrors.vue"
      ),
    meta: {
      title: "エラー | TATSUZIN",
    },
  },
  {
    path: "/cm/oidcerrors",
    name: "STDSCM04C07",
    component: () =>
      import(
        /* webpackChunkName: "STDSCM04C07" */ "@/views/CM04/STDSCM04C07VariousErrors.vue"
      ),
    meta: {
      title: "エラー | TATSUZIN",
    },
  },
  {
    path: "/fm/filemanagemain",
    name: "STFMFM01C01",
    component: () =>
      import(
        /* webpackChunkName: "STFMFM01C01" */ "@/views/FM01/STFMFM01C01DataCollectionMain.vue"
      ),
    meta: {
      title: "電帳法オプションへようこそ | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  },
  {
    path: '/fm/filemanage',
    name: 'STFMFM02C01',
    component: () => import(/* webpackChunkName: "STFMFM02C01" */ '@/views/FM02/STFMFM02C01FileManage.vue'),
    meta: {
      title: 'ファイル管理 | TATSUZIN',
    }
  },
  {
    path: '/fm/filelist',
    name: 'STFMFM02C29',
    component: () => import(/* webpackChunkName: "STFMFM02C29" */ '@/views/FM02/STFMFM02C29MainFrame.vue'),
    meta: {
      title: 'ファイル一覧 | TATSUZIN',
    }
  },
  {
    path: '/fm/addfolder',
    name: 'STFMFM02C05',
    component: () => import(/* webpackChunkName: "STFMFM02C05" */ '@/views/FM02/STFMFM02C05AddFolder.vue'),
    meta: {
      title: 'フォルダの新規作成｜TATSUZIN',
      requiresAuth: true
    }
  },
  {
    path: '/fm/editfolder',
    name: 'STFMFM02C06',
    component: () => import(/* webpackChunkName: "STFMFM02C06" */ '@/views/FM02/STFMFM02C06EditFolder.vue'),
    meta: {
      title: 'フォルダの編集｜TATSUZIN',
      requiresAuth: true
    }
  },
  {
    path: '/fm/addtransactioninfo',
    name: 'STFMFM02C07',
    component: () => import(/* webpackChunkName: "STFMFM02C07" */ '@/views/FM02/STFMFM02C07AddProperty.vue'),
    meta: {
      title: '取引情報等の登録 | TATSUZIN',
      requiresAuth: true
    }
  },
  {
    path: '/fm/edittransactioninfo',
    name: 'STFMFM02C08',
    component: () => import(/* webpackChunkName: "STFMFM02C08" */ '@/views/FM02/STFMFM02C08EditTradingInfo.vue'),
    meta: {
      title: 'ファイル・取引情報の改訂｜TATSUZIN',
      requiresAuth: true
    }
  },
  {
    path: '/fm/filedetails',
    name: 'STFMFM02C09',
    component: () => import(/* webpackChunkName: "STFMFM02C09" */ '@/views/FM02/STFMFM02C09FilePreviewDisplay.vue'),
    meta: {
      title: 'ファイル詳細｜TATSUZIN',
      requiresAuth: true
    }
  },
  {
    path: "/fm/fileconfirmation",
    name: "STDSDC01C08",
    component: () =>
      import(
        /* webpackChunkName: "STDSDC01C08" */ "@/views/DC01/STDSDC01C08FileConfirmation.vue"
      ),
    meta: {
      title: "収集ファイルの確認 | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  },
  {
    path: "/fm/bopuser",
    name: "STDSDC02C01",
    component: () =>
      import(
        /* webpackChunkName: "STDSDC02C01" */ "@/views/DC02/STDSDC02C01BopUser.vue"
      ),
    meta: {
      title: "事業者情報 | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  },
  {
    path: "/fm/addbopuser",
    name: "STDSDC02C02",
    component: () =>
      import(
        /* webpackChunkName: "STDSDC02C02" */ "@/views/DC02/STDSDC02C02AddBopUser.vue"
      ),
    meta: {
      title: "事業者情報の新規登録 | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  },
  {
    path: "/fm/updatebopuser",
    name: "STDSDC02C05",
    component: () =>
      import(
        /* webpackChunkName: "STDSDC02C05" */ "@/views/DC02/STDSDC02C05UpdateBopUser.vue"
      ),
    meta: {
      title: "事業者情報の編集 | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  },
  {
    path: "/fm/bopaccountmanage",
    name: "STDSDC02C06",
    component: () =>
      import(
        /* webpackChunkName: "STDSDC02C06" */ "@/views/DC02/STDSDC02C06BopAccountManage.vue"
      ),
    meta: {
      title: "事業者アカウント一覧 | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  },
  {
    path: "/fm/addbopaccount",
    name: "STDSDC02C07",
    component: () =>
      import(
        /* webpackChunkName: "STDSDC02C07" */ "@/views/DC02/STDSDC02C07AddBopAccount.vue"
      ),
    meta: {
      title: "事業者アカウントの発行 | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  },
  {
    path: "/fm/updatebopaccount",
    name: "STDSDC02C08",
    component: () =>
      import(
        /* webpackChunkName: "STDSDC02C08" */ "@/views/DC02/STDSDC02C08UpdateBopAccount.vue"
      ),
    meta: {
      title: "事業者アカウントの編集 | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  },
  {
    path: "/fm/securitymanage",
    name: "STDSDC05C01",
    component: () =>
      import(
        /* webpackChunkName: "STDSDC05C01" */ "@/views/DC05/STDSDC05C01SecurityManage.vue"
      ),
    redirect: "/fm/securitymanage/accountmanage",
    meta: {
      title: "セキュリティ管理 | TATSUZIN",
      icon: "favicon.ico",
      requiresAuth: true,
    },
    children: [
      {
        path: "accountmanage",
        name: "STDSDC05C02",
        component: () =>
          import(
            /* webpackChunkName: "STDSDC05C02" */ "@/views/DC05/children/STDSDC05C02AccountManage.vue"
          ),
        meta: {
          title: "アカウント管理 / セキュリティ管理 | TATSUZIN",
          icon: "favicon.ico",
          requiresAuth: true,
        },
      },
      {
        path: "updateaccount",
        name: "STDSDC05C03",
        component: () =>
          import(
            /* webpackChunkName: "STDSDC05C03" */ "@/views/DC05/children/STDSDC05C03UpdateAccount.vue"
          ),
        meta: {
          title: "アカウント編集 / セキュリティ管理 | TATSUZIN",
          icon: "favicon.ico",
          requiresAuth: true,
        },
      },
      {
        path: "functionusageauthority",
        name: "STDSDC05C05",
        component: () =>
          import(
            /* webpackChunkName: "STDSDC05C05" */ "@/views/DC05/children/STDSDC05C05FunctionUsageAuthority.vue"
          ),
        meta: {
          title: "機能利用権限 / セキュリティ管理 | TATSUZIN",
          icon: "favicon.ico",
          requiresAuth: true,
        },
      },
      {
        path: "accessauthority",
        name: "STDSDC05C06",
        component: () =>
          import(
            /* webpackChunkName: "STDSDC05C06" */ "@/views/DC05/children/STDSDC05C06AccessAuthority.vue"
          ),
        meta: {
          title: "アクセス権限設定 / セキュリティ管理 | TATSUZIN",
          icon: "favicon.ico",
          requiresAuth: true,
        },
      },
      {
        path: "loginsecurity",
        name: "STDSDC05C07",
        component: () =>
          import(
            /* webpackChunkName: "STDSDC05C07" */ "@/views/DC05/children/STDSDC05C07LoginSecurity.vue"
          ),
        meta: {
          title: "ログインセキュリティ / セキュリティ管理 | TATSUZIN",
          icon: "favicon.ico",
          requiresAuth: true,
        },
      },
      {
        path: "loginhistory",
        name: "STDSDC05C08",
        component: () =>
          import(
            /* webpackChunkName: "STDSDC05C08" */ "@/views/DC05/children/STDSDC05C08LoginHistory.vue"
          ),
        meta: {
          title: "ログイン履歴 / セキュリティ管理 | TATSUZIN",
          icon: "favicon.ico",
          requiresAuth: true,
        },
      },
      {
        path: "operationhistory",
        name: "STDSDC05C09",
        component: () =>
          import(
            /* webpackChunkName: "STDSDC05C09" */ "@/views/DC05/children/STDSDC05C09OperationHistory.vue"
          ),
        meta: {
          title: "操作履歴 / セキュリティ管理 | TATSUZIN",
          icon: "favicon.ico",
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue"),
  },
  // No5事業者機能利用権限(電帳法)
  {
    path: "/fm/authoritySetting",
    name: "STFMFM02C31",
    component: () =>
      import(
              /* webpackChunkName: "STFMFM02C31" */ "@/views/FM02/STFMFM02C31AuthoritySetting.vue"
      ),
    meta: {
      title: "事業者に対する機能利用権限の設定",
      icon: "favicon.ico",
      requiresAuth: true,
    },
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  let kinyuCode = to.path.split('/')[1]
  if(KINYU_CODE_LIST.includes(kinyuCode)){
    next( {name:'STDSCM01C05',query:{...to.query,kinyuCode}})
  }
  document.title = to.meta.title;
  var checkPage = Common.CheckPageFrom(from.name, to.name);
  if(from.name == "STDSCM01C01"   || from.name == "STDSCM01C02" ){
    sessionStorage.removeItem("toRedirectUrl")
    sessionStorage.removeItem("isOidc")
  }
  if (checkPage) {
    // 正常遷移の場合
    next();
  } else {
    // 不正遷移の場合
    next({
      name: "STDSCM04C06",
      state: {
        message: Common.getMessage("MTCL0001", []),
      },
    });
  }
  if (to.name !== "STDSCM04C06") {
    const favicon = document.querySelector("link[rel='icon']");
    favicon.href = process.env.BASE_URL + (to.meta.icon ?? "favicon.ico");
  }

});

export default router;
